import React from 'react';

const ExchangeIcon = () =>
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M2.06917 13.2835C1.19201 11.1658 1.19196 8.83324 2.06917 6.71555C2.80615 4.93637 4.08826 3.48803 5.73515 2.55018V6.09019H7.15107V0.709961H1.77079V2.12587H3.8359C0.390508 4.82385 -0.993499 9.58957 0.761005 13.8253C1.42965 15.4396 2.5106 16.8534 3.88706 17.9142C5.22151 18.9426 6.80728 19.6228 8.47282 19.8812L8.68997 18.482C5.70037 18.0181 3.22535 16.0747 2.06917 13.2835Z"
      fill="#FFC107"
    />
    <path
      d="M19.2337 13.8257C20.2555 11.3586 20.2555 8.64115 19.2337 6.17407C18.565 4.55983 17.4841 3.14595 16.1076 2.08524C14.7731 1.05682 13.1873 0.376615 11.5218 0.118164L11.3047 1.51737C14.2942 1.98127 16.7693 3.92466 17.9254 6.71594C18.8026 8.83362 18.8026 11.1662 17.9254 13.2838C17.1885 15.063 15.9064 16.5114 14.2595 17.4492V13.9092H12.8436V19.2894H18.2238V17.8735H16.1649C17.5078 16.8249 18.5639 15.4425 19.2337 13.8257Z"
      fill="#FFC107"
    />
  </svg>;

export default ExchangeIcon;



// WEBPACK FOOTER //
// ./src/shared/components/Icons/ExchangeIcon.js